import React, { useEffect, useState } from 'react';
import { FaEye, FaDownload } from 'react-icons/fa';
import '../../styles/user/totalCandidatesPage.css';
import {
  fetchTotalCandidates,
  fetchCandidateInfo,
  downloadReport 
} from '../../services/user/api';
import { Search } from 'lucide-react';

const TotalCandidatesPage = ({onViewFinalReport,onViewReportTwo }) => {
  const [candidates, setCandidates] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  // const [currentPage, setCurrentPage] = useState(0); 
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [selectedCandidateData, setSelectedCandidateData] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

const [currentPage, setCurrentPage] = useState(1);


  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc'); 
const startIndex = (currentPage - 1) * entriesPerPage;
const totalPages = Math.ceil(totalElements / entriesPerPage);

useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [search]);

useEffect(() => {
  loadCandidates(currentPage - 1, entriesPerPage, debouncedSearch); 
}, [currentPage, entriesPerPage, debouncedSearch]);

// useEffect(() => {
//   localStorage.setItem('totalCandidatesPage', currentPage);
// }, [currentPage]);



  const loadCandidates = async (page, size, searchTerm = '') => {
  try {
    setLoading(true);
    const res = await fetchTotalCandidates(page, size, searchTerm); 
    const pageData = res.data.data;

    setCandidates(pageData.content || []);
    setTotalElements(pageData.totalElements || 0);

    // ✅ reset sorting correctly
    setSortField(null);
    setSortOrder('asc');

    setFetchError(null);
  } catch (error) {
    console.error('Failed to fetch candidates', error);
    setFetchError('An error occurred while fetching data.');
    setCandidates([]);
    setTotalElements(0);
  } finally {
    setLoading(false);
  }
};


  const handleDownloadReport = async (candidateId) => {
    try {
      const response = await downloadReport(candidateId);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${candidateId}_FinalReport.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download report", error);
    }
  };

  const handleViewDetails = async (candidateId) => {
    try {
      const response = await fetchCandidateInfo(candidateId);
      if (response?.data?.status) {
        setSelectedCandidateData(response.data.data);
        setShowReportModal(true);
      } else {
        alert(response?.data?.message || 'Failed to fetch candidate info');
      }
    } catch (error) {
      alert('Error fetching candidate details');
    }
  };
  /*
const filteredCandidates = candidates.filter((c) => {
  const searchValue = search.toLowerCase();

  return (
    c.fullname?.toLowerCase().includes(searchValue) ||
    c.email?.toLowerCase().includes(searchValue) ||
    c.candidateid?.toLowerCase().includes(searchValue) ||
    String(c.mobileNumber || '').includes(searchValue)||
      String(c.dateOfBirth || '').toLowerCase().includes(searchValue) ||
    String(c.caseInitiatedDateOnly || '').toLowerCase().includes(searchValue) ||
    String(c.caseInitiatedTimeOnly || '').toLowerCase().includes(searchValue) ||
    String(c.bgcStartDate || '').toLowerCase().includes(searchValue) ||
    String(c.bgcCompletedDate || '').toLowerCase().includes(searchValue) ||
    String(c.status || '').toLowerCase().includes(searchValue)
  );
});
*/

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };
/*

  const sortedCandidates = [...filteredCandidates].sort((a, b) => {
    if (!sortField) return 0;

    let aValue = a[sortField];
    let bValue = b[sortField];

    aValue = aValue ?? '';
    bValue = bValue ?? '';

    if (typeof aValue === 'string') {
      return sortOrder === 'asc'
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    }

    if (aValue instanceof Date || sortField.includes('Date')) {
      return sortOrder === 'asc'
        ? new Date(aValue) - new Date(bValue)
        : new Date(bValue) - new Date(aValue);
    }

    return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
  });
*/

const sortedCandidates = [...candidates].sort((a, b) => {
  if (!sortField) return 0;

  let aValue = a[sortField] ?? '';
  let bValue = b[sortField] ?? '';

  // date sorting fix
  if (sortField.toLowerCase().includes('date')) {
    return sortOrder === 'asc'
      ? new Date(aValue) - new Date(bValue)
      : new Date(bValue) - new Date(aValue);
  }

  return sortOrder === 'asc'
    ? String(aValue).localeCompare(String(bValue))
    : String(bValue).localeCompare(String(aValue));
});

  const renderSortArrow = (field) => {
    if (sortField !== field) return '⇅';
    return sortOrder === 'asc' ? '↑' : '↓';
  };

  return (
    <>
      <p className="client-header">Total Candidates</p>
      <div className="client-wrapper">
        <div className="clinet-table-controls">
          <div className="entries-select">
            Show{' '}
        <select
  value={entriesPerPage}
  onChange={(e) => {
    setEntriesPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  }}
>

  <option value="10">10</option>
  <option value="50">50</option>
  <option value="100">100</option>
</select>{' '}
            entries
          </div>
          <div className="client-search-box">
            <div className="client-search-input-wrapper">
          <input
  id="client-search-input"
  type="text"
  value={search}
  onChange={(e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  }}
  placeholder="Search by any field"
/>

              <Search className="client-search-icon" size={18} />
            </div>
          </div>
        </div>

        <div className="clinet-table-container">
          {loading ? (
            <div className="loading">Loading Candidates...</div>
          ) : fetchError ? (
            <div className="error-message">{fetchError}</div>
          ) : (
            <table className="candidates-clinet-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('candidateid')}>Candidate ID {renderSortArrow('candidateid')}</th>
                  <th onClick={() => handleSort('fullname')}>Name {renderSortArrow('fullname')}</th>
                  <th onClick={() => handleSort('email')}>Email {renderSortArrow('email')}</th>
                  <th onClick={() => handleSort('mobileNumber')}>Mobile Number {renderSortArrow('mobileNumber')}</th>
                  <th onClick={() => handleSort('dateOfBirth')}>DOB {renderSortArrow('dateOfBirth')}</th>
                  <th onClick={() => handleSort('caseInitiatedDateOnlyAsString')}>Case Initiated Date {renderSortArrow('caseInitiatedDateOnlyAsString')}</th>
                  <th onClick={() => handleSort('caseInitiatedTimeOnly')}>Case Initiated Time {renderSortArrow('caseInitiatedTimeOnly')}</th>
                  <th onClick={() => handleSort('bgcStartDateOnlyString')}>BGC Start Date {renderSortArrow('bgcStartDateOnlyString')}</th>
                  <th onClick={() => handleSort('reportDateOnlyString')}>BGC Completed Date {renderSortArrow('reportDateOnlyString')}</th> {/* Use reportDateOnlyString */}
                  <th onClick={() => handleSort('bgcStatus')}>Status {renderSortArrow('bgcStatus')}</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortedCandidates.length > 0 ? (
                  sortedCandidates.map((candidate) => (
                    <tr key={candidate.candidateid}>
                      <td>{candidate.candidateid}</td>
                      <td>{candidate.fullname}</td>
                      <td>{candidate.email}</td>
                      <td>{candidate.mobileNumber}</td>
                      <td>{candidate.dateOfBirth}</td>
                      <td>{candidate.caseInitiatedDateOnlyAsString || '---'}</td>
                      <td>{candidate.caseInitiatedTimeOnly || '---'}</td>
                      <td>{candidate.bgcStartDateOnlyString || '---'}</td>
                      <td>{candidate.reportDateOnlyString || '---'}</td> 
                      <td>
                        <span className={`status-tag ${String(candidate.bgcStatus).toLowerCase()}`}>
                          {String(candidate.bgcStatus)}
                        </span>
                      </td>
                      <td>
                        <button
                          className={`icon-btn ${
                            candidate.bgcStatus === 'PENDING_SUBMISSION'
                              ? 'text-gray-400'
                              : 'text-indigo-600'
                          }`}
                          title="View Report"
                          onClick={() => onViewReportTwo(candidate.candidateid)}
                          disabled={candidate.bgcStatus === 'PENDING_SUBMISSION'}
                        >
                          <FaEye />
                        </button>

                        <button
                          className="icon-btn"
                          title={
                            candidate.bgcStatus === 'COMPLETED'
                              ? 'Download PDF'
                              : 'Available only after verification'
                          }
                          onClick={() => onViewFinalReport(candidate.candidateid)}
                          disabled={candidate.bgcStatus !== 'COMPLETED'}
                        >
                          <FaDownload
                            className={
                              candidate.bgcStatus === 'COMPLETED'
                                ? 'text-purple-600 hover:text-purple-800'
                                : 'text-gray-400'
                            }
                          />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="no-data">No matching candidates found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        {totalElements > 0 && (
          <div className="pagination">
<div className="pagination-summary">
  Showing {totalElements === 0 ? 0 : startIndex + 1} to{' '}
  {Math.min(startIndex + candidates.length, totalElements)} of {totalElements} entries
</div>

      <div className="pagination-buttons-user">
  <button
    className="page-btn"
    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}
  >
    ←
  </button>

  <button className="page-btn active">{currentPage}</button>

  {currentPage < totalPages && (
    <button
      className="page-btn"
      onClick={() => setCurrentPage(currentPage + 1)}
    >
      {currentPage + 1}
    </button>
  )}

  <button
    className="page-btn"
    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
    disabled={currentPage === totalPages}
  >
    →
  </button>
</div>

          </div>
        )}


        {showReportModal && selectedCandidateData && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="close-btn" onClick={() => setShowReportModal(false)}>×</button>
              <h2 className="modal-title">Candidate Full Report</h2>

          
              <h3>Personal Info</h3>
              <p><strong>Name:</strong> {selectedCandidateData.personalInfoResponse?.firstName} {selectedCandidateData.personalInfoResponse?.lastName}</p>
              <p><strong>Email:</strong> {selectedCandidateData.personalInfoResponse?.email}</p>
              <p><strong>Mobile:</strong> {selectedCandidateData.personalInfoResponse?.mobileNumber}</p>
              <p><strong>DOB:</strong> {selectedCandidateData.personalInfoResponse?.dateOfBirth}</p>
              <p><strong>Gender:</strong> {selectedCandidateData.personalInfoResponse?.gender}</p>
              <p><strong>Father's Name:</strong> {selectedCandidateData.personalInfoResponse?.fatherName}</p>
              <p><strong>Nationality:</strong> {selectedCandidateData.personalInfoResponse?.nationality}</p>
              <p><strong>Aadhaar Number:</strong> {selectedCandidateData.personalInfoResponse?.aadhaarCardNumber}</p>
              <p><strong>Personal Image:</strong> <a href={selectedCandidateData.personalInfoResponse?.personalImageFileName} target="_blank" rel="noreferrer">View</a></p>
              <p><strong>Aadhaar Proof:</strong> <a href={selectedCandidateData.personalInfoResponse?.aadhaarProofFileName} target="_blank" rel="noreferrer">View</a></p>

              <h3>Address Info</h3>
              <p><strong>Current:</strong> {selectedCandidateData.addressInfoResponse?.currentAddressLine1}, {selectedCandidateData.addressInfoResponse?.currentCity}</p>
              <p><strong>Proof:</strong> <a href={selectedCandidateData.addressInfoResponse?.currentAddressFile} target="_blank" rel="noreferrer">View</a></p>
              <p><strong>Permanent:</strong> {selectedCandidateData.addressInfoResponse?.permanentAddressLine1}, {selectedCandidateData.addressInfoResponse?.permanentCity}</p>
              <p><strong>Proof:</strong> <a href={selectedCandidateData.addressInfoResponse?.permanentAddressFile} target="_blank" rel="noreferrer">View</a></p>

         
              <h3>Education</h3>
              <ul>
                {selectedCandidateData.educationInfos?.map((edu, idx) => (
                  <li key={idx}>
                    <p><strong>{edu.educationLevel}</strong> - {edu.instituteName} ({edu.enrolledYear} to {edu.passingYear})</p>
                    <a href={edu.certificateFileUrl} target="_blank" rel="noreferrer">View Certificate</a>
                  </li>
                ))}
              </ul>

              <h3>Employment</h3>
              <ul>
                {selectedCandidateData.employmentInfos?.map((emp, idx) => (
                  <li key={idx}>
                    <p><strong>Company:</strong> {emp.companyName} | <strong>Title:</strong> {emp.jobTitle}</p>
                    <p><strong>From:</strong> {emp.workingFrom} <strong>To:</strong> {emp.workingTo}</p>
                    {emp.offerLetterUrl && <a href={emp.offerLetterUrl} target="_blank" rel="noreferrer">View Offer Letter</a>}
                    {emp.salarySlipsUrl && emp.salarySlipsUrl.split(',').map((url, i) => (
                      <a key={i} href={url} target="_blank" rel="noreferrer">View Slip {i + 1}</a>
                    ))}
                    {emp.bankStatementUrl && <a href={emp.bankStatementUrl} target="_blank" rel="noreferrer">View Bank Statement</a>}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TotalCandidatesPage;
